import { POReceivingCreateMultiplePutawayPage } from "@/features/po-receiving/pages/POReceivingCreateMultiplePutawayPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/receiving/$id/create")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["po_receiving.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: POReceivingCreateMultiplePutawayPage,
});
